export default class heroSlider {
  /*
   * Fires first
   */
  constructor() {
    /*
    * Initialize slider
    */
    $('.js-hero-slider').slick({
      // autoplay: false,
      // autoplaySpeed: 4500,
      arrows: true,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            arrows: false,
          },
        },
      ],
    });
  }
}
